export default __webpack_public_path__ + "static/media/qde.ffe67114.svg";